import React from 'react';
import { Link } from 'react-router-dom';

export interface GameCardProps {
  title: string;
  description: string;
  status: string;
  emoji: string;
  gradientFrom: string;
  gradientTo: string;
  borderColor: string;
  link: string;
  hideLearnMore?: boolean;
  imageUrl?: string;
}

const GameCard: React.FC<GameCardProps> = ({
  title,
  description,
  status,
  emoji,
  gradientFrom,
  gradientTo,
  borderColor,
  link,
  hideLearnMore = false,
  imageUrl,
}) => {
  return (
    <div className={`bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow border-t-4 ${borderColor}`}>
      
      {/* Image or Emoji */}
      {imageUrl ? (
        <div
          className="h-48 bg-cover bg-center"
          style={{ backgroundImage: `url('${imageUrl}')` }}
        />
      ) : (
        <div className={`h-48 bg-gradient-to-br ${gradientFrom} ${gradientTo} flex items-center justify-center`}>
          <span className="text-white text-6xl">{emoji}</span>
        </div>
      )}
      <div className="p-6">
        <h3 className="text-2xl font-bold text-tal-slate-900 mb-2">{title}</h3>
        <p className="text-tal-slate-600 mb-4">
          {description}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-sm text-tal-slate-500">{status}</span>
          {!hideLearnMore && (
            <Link
              to={link}
              className="bg-tal-blue-600 hover:bg-tal-blue-700 text-white font-medium py-2 px-4 rounded transition-colors"
            >
              Learn More
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameCard;
